var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":"图片预览","destroy-on-close":"","width":900,"maskClosable":false,"visible":_vm.visible,"footer":null},on:{"cancel":_vm.onCancel}},[_c('ahai-preview-img',{attrs:{"img-list":_vm.imgList,"img-index":_vm.imgIndex}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }